import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BusinessProfilesHttpService} from '../../../../../../services/http-services/business-profiles/business-profiles-http.service';
import {MatCalendar, MatCalendarCellClassFunction} from '@angular/material/datepicker';
import {DatePipe} from '@angular/common';
import {DaysOfWeek, WorkDays} from '../../../../../../constants/general-variables';
import {GrTermsData} from '../../../../../../services/http-services/business-profiles/business-profiles-http-interfaces';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'gr-terms-second-step',
  templateUrl: './terms-second-step.component.html',
})
export class TermsSecondStepComponent implements OnInit {
  @Input() urlParams: any;
  @Input() termsData: GrTermsData | null = null;
  @Input() sameSlots = false;
  @Input() workingDays: string[] = [];
  @Output() changeTermDate: EventEmitter<void> = new EventEmitter();
  minimalPriceForm!: FormGroup;
  differentPriceForm!: FormGroup;
  formTriedToSubmit = false;
  calendarData: any[] = [];
  calendarSelectedTermsData: any = null;
  calendarDateKeys: any[] = [];
  selectedTermsDate: any = null;
  currentSelectedDate: any;
  currentSelectedTerm: any;
  minDate: any;
  selected: Date | null = null;
  isChangeWorkTermsModalOpen = false;
  minimalPriceFormTriedToSubmit = false;
  diffPriceFormTriedToSubmit = false;
  today: any;
  tomorrow: any;
  @ViewChild('calendar') calendar!: MatCalendar<Date>;
  protected readonly WorkDays = WorkDays;
  filteredDate = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    const notWorkingDays = DaysOfWeek.filter(weekDay => {
      return this.termsData?.calendars.every(element => element.day !== weekDay.dayForDB);
    });
    return notWorkingDays.every(notWorkDay => {
      return day !== notWorkDay.number;
    });
  }

  constructor(private formBuilder: FormBuilder,
              private datePipe: DatePipe,
              private toastrService: ToastrService,
              private businessProfilesHttpService: BusinessProfilesHttpService) {
  }

  ngOnInit(): void {
    this.buildForm();
    this.today = new Date();
    this.tomorrow = new Date(this.today);
    this.tomorrow.setDate(this.today.getDate() + 1);
    this.minDate = this.tomorrow.toISOString().split('T')[0];
    this.onViewChanged(this.today);
    this.differentPriceForm.controls.every_term_same_price.valueChanges.subscribe(val => {
      if (val) {
        this.differentPriceForm.controls.time.patchValue('');
        this.currentSelectedTerm = null;
      } else {
        this.differentPriceForm.controls.time.patchValue(this.selectedTermsDate ? this.selectedTermsDate[0].start_time.slice(0, -3) : '');
      }
    });
    setTimeout(() => {
      this.calendar?.stateChanges.subscribe(() => {
        if (this.calendar.activeDate) {
          this.onViewChanged(this.calendar.activeDate);
        }
      });
    }, 1000);
    console.log('workingDays', this.workingDays)
  }

  buildForm(): void {
    this.minimalPriceForm = this.formBuilder.group({
      price: ['', Validators.required],
      every_day_same_price: [false],
      individualWorkingPrice: this.formBuilder.array([]),
    });
    this.minimalPriceForm.controls.every_day_same_price.valueChanges.subscribe(val => {
      const price = this.minimalPriceForm.get('price');
      const individualWorkingPriceArray = this.minimalPriceForm.controls.individualWorkingPrice as FormArray;
      if (val) {
        price?.setValidators([Validators.required]);
        individualWorkingPriceArray?.clear();
      } else {
        price?.clearValidators();
        individualWorkingPriceArray.clear();
        this.workingDays.forEach((day: string) => {
          individualWorkingPriceArray.push(
            this.formBuilder.group({
              day,
              price: [price?.value, Validators.required],
            })
          );
        });
      }
      price?.updateValueAndValidity();
    });
    if (this.termsData?.minimal_calendar_price.length) {
      if (this.termsData?.minimal_calendar_price
        .every((element: any) => element.price === this.termsData?.minimal_calendar_price[0].price)) {
        this.minimalPriceForm.controls.every_day_same_price.patchValue(true);
        this.minimalPriceForm.controls.price.patchValue(this.termsData?.minimal_calendar_price[0].price);
      } else {
        const priceArray = this.termsData?.minimal_calendar_price.map((element: any) => {
          return {day: element.day, price: element.price};
        });
        this.minimalPriceForm.controls.every_day_same_price.patchValue(false);
        this.minimalPriceForm.controls.individualWorkingPrice.patchValue(priceArray);
      }
    } else {
      this.minimalPriceForm.controls.every_day_same_price.patchValue(true);
      this.minimalPriceForm.controls.price.patchValue('');
    }

    this.differentPriceForm = this.formBuilder.group({
      date: ['', Validators.required],
      time: [''],
      price: ['', Validators.required],
      every_term_same_price: [false],
    });
  }

  getIndividualMinimalPriceGroup(index: number): FormGroup {
    const individualMinimalPriceArray = this.minimalPriceForm.get('individualWorkingPrice') as FormArray;
    return individualMinimalPriceArray.at(index) as FormGroup;
  }

  getCalendarData(): void {
    this.businessProfilesHttpService.getCalendarTerms({...this.urlParams}).then(res => {
      this.calendarDateKeys = [];
      this.calendarData = res.data;
      Object.values(res.data).forEach((element: any) => {
        Object.keys(element).forEach((key) => {
          if (element[key].length) {
            this.calendarDateKeys.push({key, date: this.datePipe.transform(key, 'dd.MM.yyyy')});
          }
        });
      });
      if (this.currentSelectedDate) {
        this.onSelectedDateOfTerm(this.currentSelectedDate);
      }
    });
  }

  onViewChanged(event: any): void {
    (event.getMonth() === this.today.getMonth())
      ? this.urlParams.date_from = this.datePipe.transform(this.tomorrow, 'yyyy-MM-dd')
      : this.urlParams.date_from = this.datePipe.transform(new Date(event.getFullYear(), event.getMonth(), 1), 'yyyy-MM-dd');
    this.urlParams.date_to = this.datePipe.transform(new Date(event.getFullYear(), event.getMonth() + 1, 1), 'yyyy-MM-dd');
    this.getCalendarData();
  }

  onCalendarDateChange(event: any): void {
    this.selected = event;
    const findDate = Object.values(this.calendarData.find(element => {
      return element.hasOwnProperty(this.datePipe.transform(event, 'yyyy-MM-dd'));
    }));
    this.calendarSelectedTermsData = findDate[0];
    this.isChangeWorkTermsModalOpen = true;
  }

  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    if (view === 'month' && this.termsData) {
      const date = cellDate.getDate();
      const notWorkingDate = this.termsData.not_work_days.some(element => {
        const elementDate = new Date(element.date);
        return cellDate.getFullYear() === elementDate.getFullYear() &&
          cellDate.getMonth() === elementDate.getMonth() &&
          cellDate.getDate() === elementDate.getDate();
      });
      return notWorkingDate ? 'calendar-not-work-date' : '';
    }
    return '';
  }

  onSelectedDateOfTerm(date: any): void {
    this.currentSelectedDate = date;
    this.differentPriceForm.controls.date.patchValue(date.key);
    const findDate = Object.values(this.calendarData.find(element => {
      return element.hasOwnProperty(date.key);
    }));
    this.selectedTermsDate = findDate[0];
    this.differentPriceForm.controls.every_term_same_price.patchValue(this.selectedTermsDate.every((element: any) => {
      return element.price === this.selectedTermsDate[0].price;
    }));
    this.differentPriceForm.controls.price.patchValue(this.selectedTermsDate[0].price);
    if (!this.differentPriceForm.controls.every_term_same_price.value) {
      this.differentPriceForm.controls.time.patchValue(this.selectedTermsDate[0].start_time.slice(0, -3));
    }
    if (this.currentSelectedTerm) {
      const findTerm = this.selectedTermsDate.find((element: any) => element.start_time === this.currentSelectedTerm.start_time);
      this.onSelectTerms(findTerm);
    }
  }

  onSelectTerms(selectedTerm: any): void {
    this.currentSelectedTerm = selectedTerm;
    this.differentPriceForm.controls.price.patchValue(selectedTerm.price);
    this.differentPriceForm.controls.time.patchValue(selectedTerm.start_time.slice(0, -3));
  }

  onSubmitMinimalPriceForm(): void {
    this.minimalPriceFormTriedToSubmit = true;
    if (this.minimalPriceForm.valid) {
      const bodyParams: any = {};
      bodyParams.calendars = [];
      bodyParams.calendars = this.workingDays.map((day: string, index: number) => {
        const dayObj = {
          day,
          price: '',
        };
        this.minimalPriceForm.controls.every_day_same_price.value
          ? dayObj.price = this.minimalPriceForm.controls.price.value
          : dayObj.price = this.minimalPriceForm.controls.individualWorkingPrice.value[index].price;
        return dayObj;
      });
      this.businessProfilesHttpService.postMinimalPrice(this.urlParams, bodyParams).then(res => {
        this.changeTermDate.emit();
        this.getCalendarData();
        this.toastrService.success(res.message);
      });
    }
  }

  onSubmitDifferentPriceForm(): void {
    this.diffPriceFormTriedToSubmit = true;
    if (this.differentPriceForm.valid) {
      const specificTerm = this.termsData?.specific_calendar_prices.find(element => {
        return (element.company_id === Number(this.urlParams.companyId) && element.date === this.differentPriceForm.controls.date.value && element.time && element.time.slice(0, -3) === this.differentPriceForm.controls.time.value);
      });
      this.businessProfilesHttpService.postDifferentPrice(this.urlParams, {...this.differentPriceForm.value, id: specificTerm ? specificTerm.id : undefined}).then(res => {
        this.changeTermDate.emit();
        this.getCalendarData();
        this.toastrService.success(res.message);
      });
    }
  }
}
